import { types } from "../types/windTurbine";

export function setWindTurbineMode(payload) {
  return {
    type: types.SET_WIND_TURBINE_MODE,
    payload,
  };
}

export function setPrecursorCase(payload) {
  return {
    type: types.SET_PRECURSOR_CASE,
    payload,
  };
}

// Domain Settings Actions
export function setNzSetting(payload) {
  return {
    type: types.SET_NZ_SETTING,
    payload,
  };
}

export function setNz(payload) {
  return {
    type: types.SET_NZ,
    payload,
  };
}

export function setstretchLevel(payload) {
  return {
    type: types.SET_STRETCH_LEVEL,
    payload,
  };
}

export function setStretchFactor(payload) {
  return {
    type: types.SET_STRETCH_FACTOR,
    payload,
  };
}

export function setDzMax(payload) {
  return {
    type: types.SET_DZ_MAX,
    payload,
  };
}

export function setHeightAuto(payload) {
  return {
    type: types.SET_HEIGHT_AUTO,
    payload,
  };
}

// Wind Profile Settings Actions
export function setWindProfileSettingsMode(payload) {
  return {
    type: types.SET_WIND_PROFILE_SETTINGS_MODE,
    payload,
  };
}

export function setUComponentOfGeostrophicWind(payload) {
  return {
    type: types.SET_U_COMPONENT_OF_GEOSTROPHIC_WIND,
    payload,
  };
}

export function setVComponentOfGeostrophicWind(payload) {
  return {
    type: types.SET_V_COMPONENT_OF_GEOSTROPHIC_WIND,
    payload,
  };
}

export function setHubHeight(payload) {
  return {
    type: types.SET_HUB_HEIGHT,
    payload,
  };
}

export function setWindSpeedAtHubHeight(payload) {
  return {
    type: types.SET_WIND_SPEED_AT_HUB_HEIGHT,
    payload,
  };
}

export function setWindDirectionAtHubHeight(payload) {
  return {
    type: types.SET_WIND_DIRECTION_AT_HUB_HEIGHT,
    payload,
  };
}

export function setTemperatureProfile(payload) {
  return {
    type: types.SET_TEMPERATURE_PROFILE,
    payload,
  };
}

export function setSubstanceProfile(payload) {
  return {
    type: types.SET_SUBSTANCE_PROFILE,
    payload,
  };
}

// Wind Turbine Settings Actions
export function setRotorTable(payload) {
  return {
    type: types.SET_ROTOR_TABLE,
    payload,
  };
}

export function setRotorSpeed(payload) {
  return {
    type: types.SET_ROTOR_SPEED,
    payload,
  };
}

export function setYawAngle(payload) {
  return {
    type: types.SET_YAW_ANGLE,
    payload,
  };
}

export function setRotorPlaneTiltAngle(payload) {
  return {
    type: types.SET_ROTOR_PLANE_TILT_ANGLE,
    payload,
  };
}

export function setGeneratorRatedMechanicalPower(payload) {
  return {
    type: types.SET_GENERATOR_RATED_MECHANICAL_POWER,
    payload,
  };
}

export function setActivateSpeedControl(payload) {
  return {
    type: types.SET_ACTIVATE_SPEED_CONTROL,
    payload,
  };
}

export function setActivatePitchControl(payload) {
  return {
    type: types.SET_ACTIVATE_PITCH_CONTROL,
    payload,
  };
}

export function setActivateYawControl(payload) {
  return {
    type: types.SET_ACTIVATE_YAW_CONTROL,
    payload,
  };
}

export function setYawActuatorSpeed(payload) {
  return {
    type: types.SET_YAW_ACTUATOR_SPEED,
    payload,
  };
}

export function setDragCoefficientTower(payload) {
  return {
    type: types.SET_DRAG_COEFFICIENT_TOWER,
    payload,
  };
}

export function setTangentialLengthOfRotorSegments(payload) {
  return {
    type: types.SET_TANGENTIAL_LENGTH_OF_ROTOR_SEGMENTS,
    payload,
  };
}

export function setRadialWidthOfRotorSegments(payload) {
  return {
    type: types.SET_RADIAL_WIDTH_OF_ROTOR_SEGMENTS,
    payload,
  };
}

export function setNumberOfAirfoils(payload) {
  return {
    type: types.SET_NUMBER_OF_AIRFOILS,
    payload,
  };
}

// Parameters Actions
export function setRoughnessLengthDomain(payload) {
  return {
    type: types.SET_ROUGHNESS_LENGTH_DOMAIN,
    payload,
  };
}

export function setSurfaceHeatflux(payload) {
  return {
    type: types.SET_SURFACE_HEATFLUX,
    payload,
  };
}

export function setRayleighDampingHeight(payload) {
  return {
    type: types.SET_RAYLEIGH_DAMPING_HEIGHT,
    payload,
  };
}

export function setRayleighDampeningFactor(payload) {
  return {
    type: types.SET_RAYLEIGH_DAMPENING_FACTOR,
    payload,
  };
}

export function setIntertialOscillationDampeningFactor(payload) {
  return {
    type: types.SET_INTERTIAL_OSCILLATION_DAMPENING_FACTOR,
    payload,
  };
}

export function setCanopyDragCoefficient(payload) {
  return {
    type: types.SET_CANOPY_DRAG_COEFFICIENT,
    payload,
  };
}

export function setWallHeatfluxTopSurface(payload) {
  return {
    type: types.SET_WALL_HEATFLUX_TOP_SURFACE,
    payload,
  };
}

// Runtime Actions
export function setCoresInXDirection(payload) {
  return {
    type: types.SET_CORES_IN_X_DIRECTION,
    payload,
  };
}

export function setCoresInYDirection(payload) {
  return {
    type: types.SET_CORES_IN_Y_DIRECTION,
    payload,
  };
}

export function setSimulationDuration(payload) {
  return {
    type: types.SET_SIMULATION_DURATION,
    payload,
  };
}

// Data Output Actions
export function setNetcdfDataFormat(payload) {
  return {
    type: types.SET_NETCDF_DATA_FORMAT,
    payload,
  };
}

export function setSkipTimeBeforeDataOutput(payload) {
  return {
    type: types.SET_SKIP_TIME_BEFORE_DATA_OUTPUT,
    payload,
  };
}

export function setTimeIntervalRunControlOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_RUN_CONTROL_OUTPUT,
    payload,
  };
}

export function setTimeIntervalDataOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_DATA_OUTPUT,
    payload,
  };
}

export function setTimeIntervalAverageDataOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_AVERAGE_DATA_OUTPUT,
    payload,
  };
}

export function setTimeIntervalTimeseriesOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_TIMESERIES_OUTPUT,
    payload,
  };
}

export function setTimeIntervalProfilesOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_PROFILES_OUTPUT,
    payload,
  };
}

export function setTimeInterval3DOutput(payload) {
  return {
    type: types.SET_TIME_INTERVAL_3D_OUTPUT,
    payload,
  };
}

export function setAveragingInterval(payload) {
  return {
    type: types.SET_AVERAGING_INTERVAL,
    payload,
  };
}

export function setTimePeriodForAveraging(payload) {
  return {
    type: types.SET_TIME_PERIOD_FOR_AVERAGING,
    payload,
  };
}

export function setAveragingIntervalForProfiles(payload) {
  return {
    type: types.SET_AVERAGING_INTERVAL_FOR_PROFILES,
    payload,
  };
}

export function setTimePeriodForProfilesAveraging(payload) {
  return {
    type: types.SET_TIME_PERIOD_FOR_PROFILES_AVERAGING,
    payload,
  };
}

// Load/Reset Actions
export function loadWindTurbineSettings(payload) {
  return {
    type: types.LOAD_WIND_TURBINE_SETTINGS,
    payload,
  };
}

export function loadSavedWindTurbineSettings(payload) {
  return {
    type: types.LOAD_SAVED_WIND_TURBINE_SETTINGS,
    payload,
  };
}

export function resetWindTurbineSettings() {
  return {
    type: types.RESET_WIND_TURBINE_SETTINGS,
  };
}

export function setSectionYZ(payload) {
  return {
    type: types.SET_SECTION_YZ,
    payload,
  };
}

export function setSectionXZ(payload) {
  return {
    type: types.SET_SECTION_XZ,
    payload,
  };
}

export function setMaskOverSurface(payload) {
  return {
    type: types.SET_MASK_OVER_SURFACE,
    payload,
  };
}

// POI and Wind Turbine Data Management Actions
export function setWindTurbinePoiOptions(payload) {
  return {
    type: types.SET_WIND_TURBINE_POI_OPTIONS,
    payload,
  };
}

export function setWindTurbinePoiSelected(payload) {
  return {
    type: types.SET_WIND_TURBINE_POI_SELECTED,
    payload,
  };
}

export function setWindTurbineWindTurbineOptions(payload) {
  return {
    type: types.SET_WIND_TURBINE_WIND_TURBINE_OPTIONS,
    payload,
  };
}

export function setWindTurbineWindTurbineSelected(payload) {
  return {
    type: types.SET_WIND_TURBINE_WIND_TURBINE_SELECTED,
    payload,
  };
}

export function setWindTurbineDataLoaded(payload) {
  return {
    type: types.SET_WIND_TURBINE_DATA_LOADED,
    payload,
  };
}

export function setPrecursorCaseOptions(payload) {
  return {
    type: types.SET_PRECURSOR_CASE_OPTIONS,
    payload,
  };
}